import React from 'react';


import * as dataUtils from '../../../../utils/dataUtils';
import * as stringUtils from '../../../../utils/stringUtils';

import TreeSelect from '../../../global/Form/TreeSelect';
import useRegions from '../hooks/useRegions';


function CountryPicker(props) {

    const regionByCode = useRegions();
    const regions = Object.values(regionByCode);

    if (regions.length === 0) {

        return null;
    }

    // only use regions with region code
    const filteredRegions = regions.filter(region => !!region.region);

    // and sort by region name
    const sortedRegions = dataUtils.sortBy(filteredRegions, {region: 1});

    // mapping region --> country hierarchy to tree select compatible format
    const countryItems = sortedRegions.map(({region, regionCode, subRegionByCode}) => {

        const sortedSubRegions = dataUtils.sortBy(Object.values(subRegionByCode), {
            subRegion: 1
        });

        return {
            children: sortedSubRegions.map(({countries, subRegion, subRegionCode}) => {

                const sortedCountries = dataUtils.sortBy(Object.values(countries), {
                    alpha2: 1
                });

                return {
                    children: sortedCountries.map(({alpha2, name, nativeName}) => {

                        return {
                            // content: `${alpha2} - ${name}`,
                            // eslint-disable-next-line react/no-multi-comp
                            content: () => (
                                <span>
                                    {alpha2} - {name}
                                </span>
                            ),
                            searchPredicate: filter => {

                                return alpha2 === filter
                                    || stringUtils.contains(name, filter)
                                    || stringUtils.contains(nativeName, filter);
                            },
                            value: alpha2
                        };
                    }),
                    content: subRegion,
                    isSelectable: false,
                    value: subRegionCode
                };
            }),
            content: region,
            isSelectable: false,
            value: regionCode
        };
    });

    return (
        <TreeSelect
            {...props}
            items={countryItems}
        />
    );
}


CountryPicker.propTypes = {
    ...dataUtils.removeKey(TreeSelect.propTypes, 'items')
};

CountryPicker.defaultProps = {
    isSingle: false,
    values: []
};


export default CountryPicker;
